import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../api-config";

const PrivateRoute = ({ children, requiredRole }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showContent, setShowContent] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      setLoading(false);
      return;
    }

    setShowContent(true);

    axios.get(`${API_URL}/user/me`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        setIsAuthenticated(true);
        setIsAdmin(res.data.roles.includes("Admin"));
      })
      .catch((err) => {
        console.error(err);
        localStorage.removeItem("token");
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 300);
      });
  }, []);

  if (!loading) {
    if (!isAuthenticated) {
      return <Navigate to="/login" replace />;
    }

    if (requiredRole && !isAdmin) {
      return <Navigate to="/" replace />;
    }

    return children;
  }

  return showContent ? children : null;
};

export default PrivateRoute;